import { Roda3D } from '../../caminhaoTanque/Roda3D'
import { CabineCarro3D } from './CabineCarro3D'
import { Cruz3D } from './Cruz3D'
import { BarraLuzes3D, ChevronTraseiro3D } from './DetalhesViatura3D'
import { PecaDetalhe3D as Peca } from './PecaDetalhe3D'

export type TipoViaturaCivil = 'ambulancia' | 'carro'
const VIDRO = '#294451'
const CHASSI = '#26323b'

export function FiguraViaturaCivil3D({
  tipo,
  cor,
}: {
  tipo: TipoViaturaCivil
  cor: string
}) {
  const ambulancia = tipo === 'ambulancia'
  const comprimento = ambulancia ? 6 : 4.5
  const meiaLargura = ambulancia ? 1.02 : 0.9
  const frente = comprimento / 2
  const raio = ambulancia ? 0.4 : 0.32
  const corPintura = ambulancia ? '#bc4742' : cor
  const yVidro = ambulancia ? 1.79 : 1.24
  const zVidro = ambulancia ? 2.82 : 0.923
  return (
    <group name={tipo}>
      <Peca
        posicao={[0, 0.48, 0]}
        tamanho={[meiaLargura * 1.92, 0.24, comprimento * 0.94]}
        cor={CHASSI}
        raio={0.06}
      />
      <Peca
        posicao={[0, ambulancia ? 0.88 : 0.72, 0]}
        tamanho={[meiaLargura * 2, ambulancia ? 0.88 : 0.62, comprimento]}
        cor={corPintura}
        metal={0.25}
        raio={0.16}
      />
      {ambulancia ? (
        <>
          <Peca
            posicao={[0, 1.67, -0.925]}
            tamanho={[1.87, 1.25, 4.13]}
            cor={corPintura}
            metal={0.2}
            raio={0.17}
          />
          <Peca
            posicao={[0, 1.67, 1.94]}
            tamanho={[1.87, 1.25, 1.55]}
            cor={corPintura}
            metal={0.2}
            raio={0.12}
          />
          <Peca
            posicao={[0, yVidro, zVidro]}
            tamanho={[1.73, 0.73, 0.045]}
            cor={VIDRO}
            rotacao={[-0.12, 0, 0]}
            raio={0.02}
            metal={0.4}
            rugosidade={0.13}
          />
        </>
      ) : (
        <CabineCarro3D cor={corPintura} />
      )}
      <Peca
        posicao={[0, 0.59, frente + 0.025]}
        tamanho={[meiaLargura * 1.85, 0.19, 0.12]}
        cor={CHASSI}
        raio={0.04}
      />
      <Peca
        posicao={[0, 0.77, frente + 0.03]}
        tamanho={[meiaLargura * 0.96, 0.2, 0.045]}
        cor="#18232c"
        raio={0.018}
      />
      {[0.72, 0.78, 0.84].map((y) => (
        <Peca
          key={y}
          posicao={[0, y, frente + 0.06]}
          tamanho={[meiaLargura * 0.9, 0.014, 0.015]}
          cor="#80919a"
          raio={0.005}
          metal={0.65}
        />
      ))}
      <Peca
        posicao={[0, 0.57, -frente - 0.01]}
        tamanho={[meiaLargura * 1.9, 0.15, 0.12]}
        cor={CHASSI}
        raio={0.035}
      />
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <Peca
            posicao={[lado * meiaLargura * 0.78, 0.86, frente + 0.04]}
            tamanho={[0.3, 0.14, 0.06]}
            cor="#f1f0dc"
            raio={0.035}
            rugosidade={0.18}
            realce={{ emissive: '#f1f0dc', emissiveIntensity: 0.25 }}
          />
          <Peca
            posicao={[lado * meiaLargura * 0.83, 0.89, -frente - 0.025]}
            tamanho={[0.21, ambulancia ? 0.37 : 0.14, 0.045]}
            cor="#ca4540"
            raio={0.028}
          />
          {(ambulancia ? [1.94, -0.77] : [0.36, -0.77]).map((z) => (
            <group key={z}>
              {ambulancia && (
                <Peca
                  posicao={[lado * (meiaLargura * 0.927), yVidro, z]}
                  tamanho={[0.035, ambulancia ? 0.6 : 0.43, 0.89]}
                  cor={VIDRO}
                  metal={0.4}
                  rugosidade={0.13}
                  raio={0.014}
                />
              )}
              <Peca
                posicao={[
                  lado * (meiaLargura + 0.013),
                  ambulancia ? 1.35 : 0.99,
                  z - 0.29,
                ]}
                tamanho={[0.036, 0.035, 0.16]}
                cor="#a5b4ba"
                metal={0.75}
                raio={0.01}
              />
              <Peca
                posicao={[
                  lado * (meiaLargura + 0.008),
                  ambulancia ? 1.05 : 0.79,
                  z - 0.49,
                ]}
                tamanho={[0.012, ambulancia ? 0.74 : 0.36, 0.012]}
                cor="#4f6069"
                raio={0.004}
              />
            </group>
          ))}
          <Peca
            posicao={[
              lado * (meiaLargura + 0.12),
              yVidro - 0.09,
              ambulancia ? 2.43 : 0.84,
            ]}
            tamanho={[0.27, 0.12, 0.14]}
            cor={CHASSI}
            raio={0.04}
          />
          <Peca
            posicao={[
              lado * (meiaLargura + 0.205),
              yVidro - 0.09,
              ambulancia ? 2.41 : 0.82,
            ]}
            tamanho={[0.02, 0.085, 0.095]}
            cor="#a0b5bd"
            metal={0.85}
            rugosidade={0.1}
            raio={0.008}
          />
          {[frente - 0.81, -frente + 0.81].map((z) => (
            <group key={z}>
              <Roda3D
                lado={lado * (meiaLargura - 0.065)}
                z={z}
                raio={raio}
                largura={ambulancia ? 0.27 : 0.22}
                raiada={!ambulancia}
              />
              <mesh
                position={[lado * (meiaLargura + 0.014), raio, z]}
                rotation={[0, Math.PI / 2, 0]}
              >
                <torusGeometry args={[raio + 0.035, 0.026, 6, 18, Math.PI]} />
                <meshStandardMaterial color={CHASSI} roughness={0.7} />
              </mesh>
            </group>
          ))}
          {ambulancia && (
            <>
              <Peca
                posicao={[lado * 1.028, 1.17, -0.6]}
                tamanho={[0.016, 0.12, 4.35]}
                cor="#f2f3ef"
                raio={0.006}
              />
              <group
                position={[lado * 1.04, 1.8, -1.9]}
                rotation={[0, (lado * Math.PI) / 2, 0]}
                scale={0.65}
              >
                <Cruz3D cor="#f2f3ef" />
              </group>
            </>
          )}
        </group>
      ))}
      {[-1, 1].map((lado) => (
        <Peca
          key={lado}
          posicao={[
            lado * 0.36,
            yVidro - (ambulancia ? 0.25 : 0.19),
            zVidro + 0.09,
          ]}
          tamanho={[0.5, 0.015, 0.015]}
          cor={CHASSI}
          raio={0.004}
          rotacao={[0, 0, lado * 0.1]}
        />
      ))}
      {ambulancia && (
        <>
          <BarraLuzes3D y={2.35} z={1.95} />
          <ChevronTraseiro3D largura={1.5} altura={0.52} y={1.02} z={-3.05} />
          {[-1, 1].map((lado) => (
            <Peca
              key={lado}
              posicao={[lado * 0.46, 1.77, -3.015]}
              tamanho={[0.73, 0.57, 0.035]}
              cor={VIDRO}
              metal={0.4}
              rugosidade={0.14}
              raio={0.02}
            />
          ))}
          <Peca
            posicao={[0, 1.35, -3.022]}
            tamanho={[0.018, 1.7, 0.025]}
            cor="#86949c"
            raio={0.006}
          />
          <Peca
            posicao={[0, 0.42, -3.07]}
            tamanho={[1.6, 0.12, 0.35]}
            cor="#63747d"
            metal={0.65}
            raio={0.025}
          />
        </>
      )}
    </group>
  )
}
